import Component from '@glimmer/component'
import t from 'ember-intl/helpers/t'
import didInsert from '@ember/render-modifiers/modifiers/did-insert'
import { on } from '@ember/modifier'
import { action } from '@ember/object'
import Logger from 'customer-flows/utils/logger'
import environment from 'customer-flows/config/environment'

interface SuccessImageArgs {
  theme?: AVAILABLE_THEMES
  timeout?: number
  onTimeout?: () => void
  onError?: () => void
}

const DEFAULT_TIMEOUT = 2000

// Make sure to preload the image in the route
export default class SuccessImage extends Component<SuccessImageArgs> {
  get src() {
    return `/assets/images/success-gifs/${this.args.theme ?? 'blue'}.gif`
  }

  @action
  onInsert() {
    const timeout = environment.isTesting ? 0 : this.args.timeout ?? DEFAULT_TIMEOUT
    setTimeout(() => this.args.onTimeout?.(), timeout)
  }

  @action
  onError(event: Event) {
    event.preventDefault()
    Logger.error('Error loading success image')
    this.args.onError?.()
  }

  <template>
    <img
      data-testid='ui-kit__success-image'
      src={{this.src}}
      alt={{t 'common.success'}}
      {{on 'error' this.onError}}
      {{didInsert this.onInsert}}
    />
  </template>
}
